import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTenantData } from "contexts/tenant";
import { useMemo } from "react";
import {
  ScrapTrackingTimeZone,
  selectScrapViewportTimeZone,
  setTimeZone,
} from "src/store/slices/scrapTrackingViewportSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";

/**
 * Returns the short timezone abbreviation (e.g., "CST", "EST") for a given IANA timezone.
 */
const getTimezoneAbbreviation = (ianaTimezone: string): string => {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: ianaTimezone,
    timeZoneName: "short",
  });
  const parts = formatter.formatToParts(new Date());
  return parts.find((p) => p.type === "timeZoneName")?.value ?? ianaTimezone;
};

export const TimezoneToggleButton = () => {
  const { local_timezone } = useTenantData();
  const dispatch = useAppDispatch();
  const timeZone = useAppSelector(selectScrapViewportTimeZone);

  const localTimezoneAbbrev = useMemo(
    () => getTimezoneAbbreviation(local_timezone),
    [local_timezone]
  );

  const handleTimeZoneChange = (_: unknown, value: string | null) => {
    if (!value) return;
    dispatch(setTimeZone(value as ScrapTrackingTimeZone));
  };

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      color="primary"
      value={timeZone}
      onChange={handleTimeZoneChange}
    >
      <ToggleButton value="UTC">UTC</ToggleButton>
      <ToggleButton value="local">{localTimezoneAbbrev}</ToggleButton>
    </ToggleButtonGroup>
  );
};
